const RISK_POLICY_STORAGE_PREFIX = "risk_policy_settings_";


// In your riskPolicy.js, update DEFAULT_RISK_POLICY:
const DEFAULT_RISK_POLICY = {
  low: {
    disableCod: false,
    disableReturns: false,
    blockCheckout: false,
    approvalMethod: "follow_backend",  
  },
  acceptable: {
    disableCod: false,
    disableReturns: false,
    blockCheckout: false,
    approvalMethod: "follow_backend",  // CRITICAL: Follow Flask
  },
  medium: {
    disableCod: false,
    disableReturns: false,
    blockCheckout: false,
    approvalMethod: "follow_backend",  // Follow Flask by default
  },
  high: {
    disableCod: false,  // Don't disable COD by default
    disableReturns: true,
    blockCheckout: false,
    approvalMethod: "follow_backend",  // Follow Flask by default
  },
  very_high: {
    disableCod: true,
    disableReturns: true,
    blockCheckout: true,
    approvalMethod: "block",
  },
  critical: {
    disableCod: true,
    disableReturns: true,
    blockCheckout: true,
    approvalMethod: "block",
  },
};
const sanitizeValue = (value = "") => String(value || "").trim().toLowerCase();

export const getHardcodedRiskLevel = ({ customerId = "", phone = "" } = {}) => {
  const normalizedCustomerId = sanitizeValue(customerId);
  const normalizedPhone = String(phone || "").replace(/\D/g, "");


  if (normalizedPhone.endsWith("9") || normalizedPhone.endsWith("8")) {
    return "high";
  }

  if (normalizedPhone.endsWith("7") || normalizedPhone.endsWith("6")) {
    return "medium";
  }

  if (normalizedCustomerId.includes("high")) {
    return "high";
  }

  if (normalizedCustomerId.includes("medium")) {
    return "medium";
  }

  return "low";
};

export const getRecommendedActionForRisk = (riskLevel = "low") => {
  const normalizedRisk = sanitizeValue(riskLevel);

  if (normalizedRisk === "high") {
    return "manual_review";
  }

  if (normalizedRisk === "medium") {
    return "otp_verify";
  }

  return "approve";
};

export const getRecommendedActionBySettings = ({
  businessUuid = "",
  riskLevel = "low",
  fallbackAction = "",
} = {}) => {
  const controls = getEffectiveRiskControls({ businessUuid, riskLevel });
  const configured = sanitizeValue(controls.approvalMethod);

  if (configured) {
    return configured;
  }

  return fallbackAction || getRecommendedActionForRisk(riskLevel);
};

const getRiskPolicyStorageKey = (businessUuid = "") =>
  `${RISK_POLICY_STORAGE_PREFIX}${businessUuid || "global"}`;

export const getRiskRestrictionSettings = (businessUuid = "") => {
  if (typeof window === "undefined") {
    return DEFAULT_RISK_POLICY;
  }

  try {
    const raw = window.localStorage.getItem(getRiskPolicyStorageKey(businessUuid));
    if (!raw) {
      return DEFAULT_RISK_POLICY;
    }

    const parsed = JSON.parse(raw);
    return {
      ...DEFAULT_RISK_POLICY,
      low: { ...DEFAULT_RISK_POLICY.low, ...(parsed.low || {}) },
      medium: { ...DEFAULT_RISK_POLICY.medium, ...(parsed.medium || {}) },
      high: { ...DEFAULT_RISK_POLICY.high, ...(parsed.high || {}) },
    };
  } catch (error) {
    return DEFAULT_RISK_POLICY;
  }
};

export const saveRiskRestrictionSettings = (businessUuid = "", settings = {}) => {
  if (typeof window === "undefined") {
    return;
  }

  const safeSettings = {
    ...DEFAULT_RISK_POLICY,
    low: { ...DEFAULT_RISK_POLICY.low, ...(settings.low || {}) },
    medium: { ...DEFAULT_RISK_POLICY.medium, ...(settings.medium || {}) },
    high: { ...DEFAULT_RISK_POLICY.high, ...(settings.high || {}) },
  };

  window.localStorage.setItem(
    getRiskPolicyStorageKey(businessUuid),
    JSON.stringify(safeSettings),
  );
};

export const getEffectiveRiskControls = ({ businessUuid = "", riskLevel = "low" } = {}) => {
  const settings = getRiskRestrictionSettings(businessUuid);
  const normalizedRisk = sanitizeValue(riskLevel);

  if (normalizedRisk === "high") {
    return settings.high;
  }

  if (normalizedRisk === "medium") {
    return settings.medium;
  }

  return settings.low;
};